import mergedDeLanguage from "./merged/de.json";
export default {
    ...mergedDeLanguage,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaTE4bi9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLGdCQUFnQixNQUFNLGtCQUFrQixDQUFDO0FBQ2hELGVBQWU7SUFDYixHQUFHLGdCQUFnQjtDQUNwQixDQUFDIn0=